<template>
    <v-navigation-drawer
        :width="300"
        theme="light"
        v-model="sidebar"
        fixed
        app
    >
        <div class="logo">
            <v-img
                :src="require('../assets/gamechanger-logo-white.svg')"
                :cover="false"
                height="100"
            />
        </div>

        <v-list class="sidebar">
            <template v-if="featureConfig.default.Dashboard">
                <AppNavigationItem
                    label="Dashboard"
                    icon="view-dashboard"
                    link="/"
                />
            </template>
            <template v-if="featureConfig.default.News">
                <AppNavigationItem
                    label="News"
                    icon="library"
                    link="/news"
                />
            </template>
            <template v-if="featureConfig.default.Pages">
                <AppNavigationItem
                    label="Pages"
                    icon="file"
                    :link="pagesUrl"
                />
            </template>
            <template v-if="featureConfig.default.Broadcasters">
                <AppNavigationItem
                    label="Broadcasters"
                    icon="broadcast"
                    link="/broadcasters"
                />
            </template>
            <template v-if="featureConfig.default.TourManagement">
                <AppNavigationItem
                    label="Tour Management"
                    :icon="sport === 'darts' ? 'bullseye-arrow' : 'billiards-rack'"
                    link="/tour-management"
                />
            </template>
            <template v-if="featureConfig.default.Fixtures">
                <AppNavigationItem
                    :label="this.sport === 'rugbyleague' ? 'Fixture Management' : 'Team Management'"
                    :icon="this.sport === 'rugbyleague' ? 'rugby' : 'soccer'"
                    link="/team-management"
                />
            </template>
            <template v-if="!featureConfig.default.Streamline2 && featureConfig.default.Calendar">
                <AppNavigationItem
                    label="Calendar"
                    icon="calendar-today"
                    link="/calendar"
                />
            </template>
            <!-- <template v-if="featureConfig.default.Fixtures">
        <AppNavigationItem label="Fixtures" icon="calendar_today" link="/fixtures" />
      </template>
      <template v-if="featureConfig.default.Squads">
         <AppNavigationItem label="Squads" icon="group" link="/squads" />
      </template> -->
            <template v-if="featureConfig.default.Organisations">
                <AppNavigationItem
                    label="Organisations"
                    icon="map-marker-plus-outline"
                    link="/organisations"
                />
            </template>
            <template v-if="featureConfig.default.MapDirectory">
                <AppNavigationItem
                    label="Map Directory"
                    icon="map-marker-plus-outline"
                    link="/map-directory"
                />
            </template>
            <template v-if="featureConfig.default.Forms">
                <AppNavigationItem
                    label="Forms"
                    icon="clipboard-text"
                    link="/forms"
                />
            </template>
            <template v-if="featureConfig.default.Videos">
                <AppNavigationItem
                    v-if="featureConfig.default.Streamline"
                    label="Streamline/Videos"
                    icon="video-box"
                    link="/video-management"
                />
                <AppNavigationItem
                    v-else
                    label="Videos"
                    icon="video-box"
                    link="/video-management"
                />
            </template>
            <template v-if="featureConfig.default.Media">
                <AppNavigationItem
                    label="Media"
                    icon="wallpaper"
                    link="/media"
                />
            </template>
            <template v-if="featureConfig.default.OverlayPromos">
                <AppNavigationItem
                    label="Overlay Promos"
                    icon="dock-window"
                    link="/overlay-promos"
                />
            </template>
            <template v-if="featureConfig.default.Advertising || permissions.Advertising2">
                <AppNavigationItem
                    label="Advertising"
                    icon="picture-in-picture-bottom-right"
                    link="/advertising"
                    :restriction="
                        (restrictedPermissions.Advertising && restrictedPermissions.Advertising.length > 0 && restrictedPermissions.Advertising) ||
                        (restrictedPermissions.Advertising2 && restrictedPermissions.Advertising2.length > 0 && restrictedPermissions.Advertising2)
                    "
                />
            </template>
            <template v-if="featureConfig.default.Lab">
                <AppNavigationItem
                    label="[Alpha] Advertising"
                    icon="flask-empty"
                    link="/lab"
                />
            </template>
            <template v-if="featureConfig.default.Sponsors">
                <AppNavigationItem
                    label="Sponsors"
                    icon="picture-in-picture-top-right"
                    link="/sponsors"
                />
            </template>
            <template v-if="featureConfig.default.Rankings">
                <AppNavigationItem
                    label="Rankings"
                    :icon="sport === 'snooker' ? 'billiards-rack' : 'trophy'"
                    link="/rankings"
                />
            </template>
            <template v-if="featureConfig.default.AppConfig">
                <AppNavigationItem
                    label="App Manager"
                    icon="cellphone-cog"
                    link="/app-management"
                />
            </template>
            <template v-if="featureConfig.default.AggregatedContentFeed">
                <AppNavigationItem
                    label="App Content Feed"
                    icon="view-compact"
                    link="/content-feed"
                />
            </template>
            <template v-if="featureConfig.default.Settings">
                <AppNavigationItem
                    label="Global Settings"
                    icon="settings"
                    link="/global-settings"
                />
            </template>
            <template v-if="featureConfig.default.SiteConfig">
                <AppNavigationItem
                    label="Website Manager"
                    icon="application"
                    link="/website-management"
                />
            </template>
            <template v-if="featureConfig.default.ConfigManager">
                <AppNavigationItem
                    label="Settings Manager"
                    icon="cog-outline"
                    link="/settings-management"
                />
            </template>
            <template v-if="featureConfig.default.SsoUsers || featureConfig.default.Streamline">
                <AppNavigationItem
                    label="User Management"
                    icon="account-search"
                    link="/users"
                />
            </template>
            <template v-if="featureConfig.default.Profile">
                <AppNavigationItem
                    label="My Profile"
                    icon="account-cog"
                    link="/profile"
                />
            </template>
            <template v-if="featureConfig.default.Admin">
                <AppNavigationItem
                    label="Admin Users"
                    icon="shield-account-variant"
                    link="/admin-users"
                />
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import AppNavigationItem from "@/components/AppNavigationItem"

export default {
    name: "AppNavigation",

    components: {
        AppNavigationItem
    },

    computed: {
        pagesUrl() {
            const usesLegacyPages = process.env.VUE_APP_CLUB_ID === "wst"
            return usesLegacyPages ? "/pages" : "/pagebuilder/page/homepage"
        },

        sidebar: {
            get() {
                return this.$store.state.sidebar
            },
            set(val) {
                this.$store.commit("toggleSidebar", val)
            }
        }
    },

    data() {
        return {
            permissions: {}, // Eventually all permissions can be migrated to use this variable instead of the below
            restrictedPermissions: {},
            featureConfig: null,
            sport: process.env.VUE_APP_SPORT
        }
    },

    created() {
        this.featureConfig = require("../config/features/" + process.env.VUE_APP_CLUB_ID + "/modules.js")

        this.getPermissions()
    },

    methods: {
        getPermissions() {
            if (!this.$store.state.user.email) {
                setTimeout(() => {
                    this.getPermissions()
                }, 1000)
            } else {
                if (!this.$gcPermissions().user) {
                    this.$gcPermissions().defineUser(this.$store.state.user.email)
                }

                this.permissions = this.$gcPermissions().getUserPermissions()
                this.restrictedPermissions = this.$gcPermissions().getRestrictedPermissions()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.sidebar {
    padding-bottom: 68px;
    background-color: #24002f;
}

.v-theme--light {
    &.v-navigation-drawer {
        color: #94979b;
        background-color: #24002f;
    }
}

.logo {
    padding: 0 30px;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #24002f;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);
}
</style>
